import PropTypes from 'prop-types';

const NotificationsPropType = {
  children: PropTypes.string,
};

export default NotificationsPropType;
